





































































import { Component, Vue, Provide ,Prop,Watch} from "vue-property-decorator";
import { RewardItemEnum,RewardCategoryEnum } from "@/enum/index";
const deleteDialog = () => import("@/views/peopleManagement/components/deleteDialog.vue");


@Component({
    name: "reward",
     components: { deleteDialog }
})
export default class CombinationProperty extends Vue {

    @Prop() rewardAdd: any;
    @Prop() rewardDetail: any;
    @Prop() detailInfo: any;
    @Prop() rewardLoading:any;

    @Provide() private dialogVisible: Boolean = false;
    @Provide() private detailForm: any = {};
    @Provide() private rewardHeight: any = {};

    @Provide() private RewardItemEnum: any = Reflect.ownKeys(RewardItemEnum).slice(1).map((item: any, index: number) => {
        let obj: {
            label: string;
            value: number | null;
        } = { label: "", value: null };
        switch (index) {
            case 0:
            obj.label = "formWrh.oralWarning";
            break;
            case 1:
            obj.label = "formWrh.commitLetter";
            break;
            case 2:
            obj.label = "formWrh.warningLetter";
            break;
        }
        obj.value = index + 1;
        return obj;
    }); // 惩罚类型

    @Provide() private RewardCategoryEnum: any = Reflect.ownKeys(RewardCategoryEnum).slice(1).map((item: any, index: number) => {
        let obj: {
            label: string;
            value: number | null;
        } = { label: "", value: null };
        switch (index) {
            case 0:
            obj.label = "formWrh.complianceIssues";
            break;
            case 1:
            obj.label = "formWrh.businessIssues";
            break;
            case 2:
            obj.label = "formWrh.disciplinaryIssues";
            break;
        }
        obj.value = index + 1;
        return obj;
    }); // 问题类型

    //工作经历
    @Provide() private rewardForm: any = {
        listList:[],
        panelstatus:0,
    };
    @Provide() private rewardRecord: any = {
        rewardTimes:0,
        punishTimes:0,
        letter:0
    };
   
    @Watch("detailInfo")
    onDetailInfoChanged(val: any) {
        if (val) {
            this.detailForm = JSON.parse(JSON.stringify(this.detailInfo.reward))
            let list =  this.detailForm.listList
            if(list.length > 0){
                this.rewardRecord = {
                    rewardTimes:0,
                    punishTimes:0,
                    letter:0
                }

                this.detailInfo.reward.listList.forEach((item:any,index:any) => {
                    item.itemId = index
                    if(list[index].rewardtype == 1){
                        this.rewardRecord.rewardTimes = ++this.rewardRecord.rewardTimes
                    }else if(list[index].rewardtype == 2){
                        this.rewardRecord.punishTimes = ++this.rewardRecord.punishTimes
                        if(list[index].rewarditem == 3){
                            this.rewardRecord.letter = ++this.rewardRecord.letter
                        }
                    }
                })
            }
            this.rewardForm = JSON.parse(JSON.stringify(this.detailInfo.reward))
            this.$emit('initForm',this.rewardForm,'6')
        }
    }
    private created () {
        this.$emit('initForm',this.rewardForm,'6')
    }

    //submit
    private submitForm(formName:string){
        let ref: any = this.$refs[formName];
        ref.validate((valid:any) => {
            if (valid) {
                this.rewardForm.panelstatus = 0
                this.$emit('submitForm',this.rewardForm,'6')
            } else {
                return false;
            }
        });
    }
    // reset
    private  resetForm(formName:string) {
        let ref: any = this.$refs[formName];
        ref.resetFields();
        this.rewardForm.listList.forEach((item:any,index:any) => {
            if(item.id == 0){
                this.rewardForm.listList.splice(index,1)
            }
        });
        this.$emit('resetForm','6')
    }

     // show add
    private addInfo () {
        this.$emit('addForm','6')
    }

    // edit
    private editInfo () {
        this.rewardForm = JSON.parse(JSON.stringify(this.detailInfo.reward))
        this.$emit('editForm','6')
    }

    private rewardChange(item:any,index:any){
        let list = this.rewardForm.listList
        list.forEach((items:any) => {
            if(items.itemId == index) {
                items.rewarditem = ''
                items.rewardcategory = ''
                items.amount = ''
                item.remark = ''
            }
        });
    };


    private addRewardList () {
        let list = JSON.parse(JSON.stringify(this.rewardForm.listList))
        // return
        if(list.length > 0){
            let num:any = 0
            for(let i = 0 ; i < list.length ; i++){
                if(list[i].panelstatus == 0){
                    if(list[i].rewardtype == '' || list[i].remark == ''){
                        num++ 
                    }else if(list[i].rewardtype == 1){
                        //奖励
                        if(list[i].amount == ''){
                            num++
                        }
                    }else{
                        //惩罚
                        if(list[i].rewardcategory == '' || list[i].rewarditem == '' || list[i].rewardcategory == 0 || list[i].rewarditem == 0){
                            num++
                        }
                    }
                }
            }
            if(num == 0){
                this.rewardForm.listList.push({
                    id:0,
                    rewardtype:'',
                    rewardcategory:'',
                    rewarditem:'',
                    amount:'',
                    remark:'',
                    panelstatus:0,
                    itemId:this.rewardForm.listList.length
                })
            }

        }else{
            this.rewardForm.listList.push({
                id:0,
                rewardtype:'',
                rewardcategory:'',
                rewarditem:'',
                amount:'',
                remark:'',
                panelstatus:0,
                itemId:this.rewardForm.listList.length
            })
        }
    }

    private deleteReward (index:any){
         let list = this.rewardForm.listList
        // 点击删除则直接把状态置为1，如果是新增，服务端会自动删除掉该条数据
        list[index].panelstatus = 1
        this.$forceUpdate()
    }

    private deleteInfo () {
        //弹框提示是否删除
        this.dialogVisible = true
    }
    private cancelConfirm () {
        this.dialogVisible = false
    }
    private deleteConfirm () {
        this.dialogVisible = false
        this.$emit('deleteForm','6')
    }

    private amountChange (e:any){
        // this.rewardForm.amount = e

    }

}
